import { JSX, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navbar, NavbarBrand } from 'reactstrap';
import { RootReducerState } from '../../../redux/Reducers';
import { useTheme } from '../../../hooks/useTheme';
import telcloudLogoFallback from '../../../assets/images/logo-light-text.png';

const SimpleHeader = (): JSX.Element => {
  const settings = useSelector((state: RootReducerState) => state.utilsReducer);
  const { domainTheme: domainData } = useTheme();

  const [navbarBgColor, setNavbarBgColor] = useState(
    domainData?.navbar_color ? { backgroundColor: domainData.navbar_color } : undefined
  );

  useEffect(() => {
    if (domainData?.navbar_color) setNavbarBgColor({ backgroundColor: domainData.navbar_color });
    else setNavbarBgColor(undefined);
  }, [domainData]);

  const logoSrc = domainData?.navbar_logo || domainData?.logo || telcloudLogoFallback;
  const logoAlt = domainData?.name ? `${domainData.name} logo` : 'TelCloud logo';

  return (
    <header style={navbarBgColor} className='topbar navbarbg' data-navbarbg={'skin8'}>
      <Navbar className={'top-navbar navbar-dark'} expand='md' style={navbarBgColor || { background: '#161d29' }}>
        <div className='navbar-header' id='logobg' data-logobg={settings.activeLogoBg} style={navbarBgColor}>
          <NavbarBrand href='/'>
            <span className='logo-text'>
              <img src={logoSrc} alt={logoAlt} style={{ width: '175px', height: '40px', objectFit: 'contain' }} />
            </span>
          </NavbarBrand>
        </div>
      </Navbar>
    </header>
  );
};

export default SimpleHeader;
